/**
 * src/pages/ForgotPassword.jsx
 * Solicita el enlace de restablecimiento de contraseña por email.
 * La respuesta del backend es idéntica exista o no la cuenta (sin enumeración).
 */
import { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../api/client'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [enviado, setEnviado] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email) { setError('Escribe tu email'); return }
    setLoading(true); setError('')
    try {
      await api.post('/auth/forgot', { email })
      setEnviado(true)
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo enviar la solicitud. Inténtalo de nuevo.')
    } finally { setLoading(false) }
  }

  const inputStyle = {
    width: '100%', background: 'var(--color-surface-2)',
    border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)',
    padding: '10px 14px', fontSize: 'var(--text-md)', fontFamily: 'var(--font-ui)',
    color: 'var(--color-text)', outline: 'none', boxSizing: 'border-box',
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-5)' }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-6)' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontWeight: 500, fontSize: 'var(--text-lg)', color: 'var(--color-text)' }}>CM Monitor</div>
          <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-3)', fontFamily: 'var(--font-mono)', letterSpacing: '0.08em', marginTop: 'var(--space-1)' }}>RECUPERAR CONTRASEÑA</p>
        </div>
        <div style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-lg)', padding: '28px', boxShadow: 'var(--shadow-lg)' }}>
          {enviado ? (
            <div>
              <p style={{ fontSize: 'var(--text-md)', color: 'var(--color-text)', lineHeight: 1.5 }}>
                Si existe una cuenta con <b>{email}</b>, te hemos enviado un correo
                con el enlace para elegir una contraseña nueva. Es válido durante
                30 minutos — revisa también la carpeta de spam.
              </p>
              <p style={{ textAlign: 'center', marginTop: '18px', fontSize: 'var(--text-base)' }}>
                <Link to="/acceder" style={{ color: 'var(--color-accent)', textDecoration: 'none' }}>Volver a iniciar sesión</Link>
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <p style={{ fontSize: 'var(--text-base)', color: 'var(--color-text-2)', lineHeight: 1.5, margin: 0 }}>
                Escribe el email de tu cuenta y te enviaremos un enlace para
                elegir una contraseña nueva.
              </p>
              <div>
                <label style={{ display: 'block', fontSize: 'var(--text-xs)', fontWeight: 500, color: 'var(--color-text-2)', marginBottom: '5px', fontFamily: 'var(--font-mono)', letterSpacing: '0.05em' }}>EMAIL</label>
                <input type="email" style={inputStyle} name="email" autoComplete="email" value={email}
                  onChange={e => setEmail(e.target.value)} placeholder="tu@empresa.cl" disabled={loading}
                  onFocus={e => e.target.style.borderColor = 'var(--color-accent)'}
                  onBlur={e => e.target.style.borderColor = 'var(--color-border)'} />
              </div>
              {error && <div style={{ background: 'var(--color-error-soft)', border: '1px solid var(--color-error-line)', borderRadius: 'var(--radius-sm)', padding: '10px 12px', fontSize: 'var(--text-sm)', color: 'var(--color-error)', fontFamily: 'var(--font-mono)' }}>{error}</div>}
              <button type="submit" disabled={loading} style={{ width: '100%', background: 'var(--color-accent)', color: 'var(--color-on-accent)', border: 'none', borderRadius: 'var(--radius-md)', padding: '11px', fontSize: 'var(--text-md)', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'var(--font-ui)' }}>
                {loading ? 'Enviando…' : 'Enviarme el enlace'}
              </button>
              <p style={{ textAlign: 'center', margin: 0, fontSize: 'var(--text-base)' }}>
                <Link to="/acceder" style={{ color: 'var(--color-text-3)', textDecoration: 'none' }}>Volver a iniciar sesión</Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}
